import {useMultiFeatureAnalysisStats} from 'app/components/Dashboard/hooks/useAggregatedFeatureStats';
import {getAllSortedTimestamps} from 'app/components/Dashboard/utils/chartUtils';
import {DASHBOARD_ERRORS} from 'app/utils/constants';
import {getLayer} from 'app/utils/layerUtils';

import {MultifeatureAnalysisConfig} from '../types';

export function useMultiFeatureAnalysisData(
  organizationId: string,
  widgetConfig: MultifeatureAnalysisConfig
) {
  const {data, isLoading, error} = useMultiFeatureAnalysisStats(organizationId, widgetConfig);

  const layer = getLayer(widgetConfig.layerKey);
  const allDates = getAllSortedTimestamps(data);

  const noDataFound =
    !isLoading &&
    data &&
    Object.values(data).every((feature) => feature.error === DASHBOARD_ERRORS.NO_STATISTICS_FOUND);

  return {
    data,
    isLoading,
    error,
    layer,
    allDates,
    noDataFound,
  };
}
